import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '../../components/common/Typography';

import previousAdd1 from '../../asset/img/previous_add_1.svg';
import previousAdd2 from '../../asset/img/previous_add_2.svg';
import previousAddIcon from '../../asset/img/previous_add_icon.svg';

const AddButtonSection = ({ onClickButton }) => {
  const { t } = useTranslation('previousEmployment');

  const buttonList = [
    {
      type: '1', // 전직장
      text: t('addSection.addPrevious'),
      img: previousAdd1,
    },
    {
      type: '2', // 납세조합
      text: t('addSection.addTaxUnion'),
      img: previousAdd2,
    },
  ];

  return (
    <div className="addButtonSection">
      <Typography variant="subtitleBold">{t('addSection.title')}</Typography>
      <div className="addButtonContainer">
        {buttonList.map(button => (
          <div key={button.type} className="addButton" onClick={() => onClickButton(button.type)}>
            <div className="addButtonText">
              <Typography variant="body1Bold">{button.text}</Typography>
              <img src={previousAddIcon} alt="추가" className="addIcon" />
            </div>
            <img src={button.img} alt={button.text} className="addButtonImg" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default AddButtonSection;
